export default __webpack_public_path__ + "static/media/user-img-placeholder-2.b06e976f.png";